import { render, staticRenderFns } from "./ClientPart.vue?vue&type=template&id=41036d48&scoped=true"
import script from "./ClientPart.vue?vue&type=script&lang=js"
export * from "./ClientPart.vue?vue&type=script&lang=js"
import style0 from "./ClientPart.vue?vue&type=style&index=0&id=41036d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41036d48",
  null
  
)

export default component.exports